/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPerfume = createReactComponent("perfume", "IconPerfume", [
  ["path", { d: "M10 6v3", key: "svg-0" }],
  ["path", { d: "M14 6v3", key: "svg-1" }],
  [
    "path",
    {
      d: "M5 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z",
      key: "svg-2"
    }
  ],
  ["path", { d: "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-3" }],
  ["path", { d: "M9 3h6v3h-6z", key: "svg-4" }]
]);

export { IconPerfume as default };
//# sourceMappingURL=IconPerfume.js.map
